import { CatalogItemViewModel } from '@common/model/catalog/item/view';

const getRandomArrayIndex = (array: Array<unknown>) => Math.floor(Math.random() * array.length);

export const setFakeOnlineStatus = (items: Array<CatalogItemViewModel | null>) => {
  const filteredItems = items.filter((item): item is Required<CatalogItemViewModel> => {
    return item !== null && item.clientProfile !== undefined;
  });
  const variants = [Math.floor(filteredItems.length / 9), Math.ceil(filteredItems.length / 9)];

  const targetOnlineCount = Math.min(filteredItems.length, filteredItems.length < 9 ? 0 : variants[getRandomArrayIndex(variants)]);

  let onlineCounter = 0;
  let item: Required<CatalogItemViewModel>;
  for (item of filteredItems) {
    if (item.clientProfile.isOnline) {
      onlineCounter += 1;
    }
  }
  while (onlineCounter < targetOnlineCount) {
    const i = getRandomArrayIndex(filteredItems);
    item = filteredItems[i];
    if (item.clientProfile.isOnline) {
      continue;
    }
    filteredItems[i] = { ...item, clientProfile: { ...item.clientProfile, isOnline: true } };
    onlineCounter += 1;
  }
  return filteredItems;
};
